<template lang="html">
	<div class="sub-main column">
    <div class="sub-nav row">
		<nav>
			<router-link :to="{ name: item.uri }" class="item" v-for="item in menu" v-bind:key="item.key">
				{{ item.name }}
			</router-link>
		</nav>
    </div>
		<div class="sub-page center column">
			<router-view></router-view>
		</div>
  </div>
</template>

<script>
export default {
	name: 'Transactions',
	data () {
		return {
			search: null,
			menu: [
				{
					key: 0,
					name: 'Mes opérations',
					uri: 'TransactionsTable'
				},
				{
					key: 1,
					name: 'Mes abonnements',
					uri: 'subscriptions'
				},
				{
					key: 2,
					name: 'Documents',
					uri: 'Documents'
				}
			]
		}
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?d97dedf2